import api from './client'

// Comunicaciones → WhatsApp (bandeja multiusuario). Ver docs/diseno-whatsapp-lgr.md.
const base = '/comunicaciones/whatsapp'

export const whatsappApi = {
  estado: () => api.get(`${base}/estado`),

  conversaciones: (params) => api.get(`${base}/conversaciones`, { params }),
  resumen: () => api.get(`${base}/conversaciones/resumen`),
  conversacion: (id) => api.get(`${base}/conversaciones/${id}`),
  responder: (id, texto, responde_a_id) => api.post(`${base}/conversaciones/${id}/responder`, { texto, responde_a_id }),
  adjunto: (id, archivo, texto) => {
    const fd = new FormData()
    fd.append('archivo', archivo)
    if (texto?.trim()) fd.append('texto', texto)
    return api.post(`${base}/conversaciones/${id}/adjunto`, fd)
  },
  reenviar: (mensajeId, conversacion_id) => api.post(`${base}/mensajes/${mensajeId}/reenviar`, { conversacion_id }),
  nota: (id, texto) => api.post(`${base}/conversaciones/${id}/nota`, { texto }),
  tomar: (id) => api.post(`${base}/conversaciones/${id}/tomar`),
  asignar: (id, data) => api.post(`${base}/conversaciones/${id}/asignar`, data),
  resolver: (id) => api.post(`${base}/conversaciones/${id}/resolver`),
  cerrar: (id, motivo) => api.post(`${base}/conversaciones/${id}/cerrar`, { motivo }),
  reabrir: (id) => api.post(`${base}/conversaciones/${id}/reabrir`),
  spam: (id) => api.post(`${base}/conversaciones/${id}/spam`),
  noSpam: (id) => api.post(`${base}/conversaciones/${id}/no-spam`),
  actualizar: (id, data) => api.patch(`${base}/conversaciones/${id}`, data),
  vincularCliente: (id, cliente_id) => api.post(`${base}/conversaciones/${id}/vincular-cliente`, { cliente_id }),
  // Varias fichas por número (sugerencia #67)
  desvincularCliente: (id, cliente_id) => api.post(`${base}/conversaciones/${id}/desvincular-cliente`, { cliente_id }),
  usarCliente: (id, cliente_id) => api.post(`${base}/conversaciones/${id}/usar-cliente`, { cliente_id }),
  reclamar: (mensajeId) => api.post(`${base}/mensajes/${mensajeId}/reclamar`),
  media: (mensajeId) => api.get(`${base}/mensajes/${mensajeId}/media`, { responseType: 'blob' }),

  lineas: () => api.get(`${base}/lineas`),
  crearLinea: (data) => api.post(`${base}/lineas`, data),
  actualizarLinea: (id, data) => api.put(`${base}/lineas/${id}`, data),
  equipos: () => api.get(`${base}/equipos`),
  crearEquipo: (data) => api.post(`${base}/equipos`, data),
  actualizarEquipo: (id, data) => api.put(`${base}/equipos/${id}`, data),
  etiquetas: () => api.get(`${base}/etiquetas`),
  crearEtiqueta: (data) => api.post(`${base}/etiquetas`, data),
  actualizarEtiqueta: (id, data) => api.put(`${base}/etiquetas/${id}`, data),
  agentes: () => api.get(`${base}/agentes`),
  buscarClientes: (q) => api.get(`${base}/buscar-clientes`, { params: { q } }),
}

export const CATEGORIAS = [
  ['ventas', 'Ventas'], ['postventa', 'Postventa'], ['logistica', 'Logística'], ['facturacion', 'Facturación'],
  ['corporativos', 'Corporativos'], ['wine_club', 'Wine Club'], ['proveedores', 'Proveedores'], ['otros', 'Otros'],
]

export const ESTADO_LABEL = {
  abierta: 'Sin asignar', asignada: 'Asignada', esperando_cliente: 'Esperando cliente', resuelta: 'Resuelta',
  cerrada: 'Cerrada', spam: 'Spam', ia_atendiendo: 'IA atendiendo', esperando_humano: 'Pendiente humano',
}
